import CLIENT from '../utils/restClient';
import Logger, {LOG_LEVELS} from '../utils/logger';

export const MODULE_NAME = 'FILING_OPTIONS_CONTROLLER';
const log = new Logger(MODULE_NAME, LOG_LEVELS.DEBUG);

function namespaced(name) {
  return MODULE_NAME+'.'+name;
}
const LOAD = namespaced('LOAD');
const LOAD_OK = namespaced('LOAD_OK');
const LOAD_FAIL = namespaced('LOAD_FAIL');
const SELECT_FILING_OPTION = namespaced('SELECT_FILING_OPTION');
const LOAD_FILTERED_DATA = namespaced('LOAD_FILTERED_DATA')
const LOAD_FILTERED_DATA_OK = namespaced('LOAD_FILTERED_DATA_OK')
const LOAD_FILTERED_DATA_FAIL = namespaced('LOAD_FILTERED_DATA_FAIL')


export const ACTION_TYPES = {
  LOAD,
  LOAD_OK,
  LOAD_FAIL,
  SELECT_FILING_TYPE: SELECT_FILING_OPTION,
  LOAD_FILTERED_DATA,
  LOAD_FILTERED_DATA_OK,
  LOAD_FILTERED_DATA_FAIL
};

// In redux parlance, this is a reducer
export const updateSubStateFromAction = (state = {data: undefined, loading: false, error: null, uploading: false}, action) => {
  log.debug('updateSubStateFromAction: ', action, state );
  const getNewState = (action, state) => {
    switch (action.type) {
      case LOAD:
        return  Object.assign({}, state, {data: undefined, loading: true, error: null});
      case LOAD_OK:
        return Object.assign({}, state, {data: action.response, loading: false, error: null});
      case LOAD_FAIL:
        return Object.assign({}, state, {data: undefined, loading: false, error: action.error});
      case SELECT_FILING_OPTION:
        return Object.assign({}, state, {selectedFilingOption: action.selectedFilingOption});
      case LOAD_FILTERED_DATA:
        return Object.assign({}, state, {filteredFilingOptions: undefined, loading: true, error: null});
      case LOAD_FILTERED_DATA_OK:
        return Object.assign({}, state, {filteredFilingOptions: action.response, loading: false, error: null});
      case LOAD_FILTERED_DATA_FAIL:
        return Object.assign({}, state, {filteredFilingOptions: undefined, loading: false, error: action.error});
      default:
        return state;
    }
  };
  const newState = getNewState(action, state);
  log.debug('updateSubStateFromAction:  newState', newState );
  return newState;
};

export const API = {
  doLoad: (filterParams) => {
    return (dispatch) => {
      dispatch({type: LOAD});
      log.debug('doLoad(): filterParams: ', filterParams);
      return CLIENT.getFilingOptions(filterParams)
        .then((response) => {
          dispatch({type: LOAD_OK, response: response});
        })
        .catch((error) => {
          dispatch({type: LOAD_FAIL, error});
        });
    }
  },
  selectFilingOption: (filingOption) => {
    return (dispatch) => {
      dispatch({type: SELECT_FILING_OPTION, selectedFilingOption: filingOption});
    }
  },
  getFilteredFilingOptions: (filterParams) => {
    return (dispatch) => {
      dispatch({type: LOAD_FILTERED_DATA});
      log.debug('doLoad(): filterParams: ', filterParams);
      return CLIENT.fetchFilteredFilingOptionsFromAPI(filterParams)
        .then((response) => {
          dispatch({type: LOAD_FILTERED_DATA_OK, response: response});
        })
        .catch((error) => {
          dispatch({type: LOAD_FILTERED_DATA_FAIL, error});
        });
    }
  },
};

export default API;